export const getPersonaData = state => state.personaData;
export const getTraits = state => getPersonaData(state).traits;

export const hasDownloadedMobileApp = state => (
  getTraits(state).nurture_bar_download_the_mobile_app_v_2 || false
);
